module.exports = __webpack_public_path__ + "static/media/badge.29528d96.png";